import React from "react";
import "./Banner.scss";
import myPhoto from "../../assets/images/zaziba.jpeg";
import Resume from "../../assets/Resume.pdf";
const Banner = () => {
  return (
    <div className="banner-container">
      <div className="info">
        <h1>
          <span className="title">👋 Hello, I'm Zaziba!</span>
        </h1>
        <div className="about-me">
        <p>
          I'm a software developer with industry experience in building scalable websites and web applications.
          My specialty is front-end development, and worked with <b>Angular</b> for over 2 years. 
          However, I'm also comfortable with <b>React</b> ⚛️. I have a strong passion for creating simple, 
          functional, and beautiful web applications 🌟. I started with <b>Java</b> in university ☕, and  
          I’ve been expanding my skills to full-stack development with a few personal projects 
          using <b>Node.js</b> 🖥️.
        </p>

        <p>
          🎓 Currently, I'm pursuing my Master’s in Applied Computer Science (Co-op) at <b>Concordia University</b> in 
          Montreal, Canada 🇨🇦. When I'm not coding, you’ll probably find me traveling, snapping photos 📸, painting 🎨, or doodling 😂.
          Want to see what I've worked on? Just scroll down to check out some of my projects! 👇
        </p>
        </div>
      </div>
      <div className="photo">
        <div>
          <img
            style={{
              width: "250px",
              height: "250px",
              borderRadius: "50%",
              filter: "grayscale(20%)",
              objectFit: "cover",
              objectPosition: "0px 0px",
            }}
            src={myPhoto}
            alt="profile"
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
